export default "__VITE_ASSET__CO$yAnFC__"